import React, { useState } from "react";
import LegalModal from "./legal/LegalModal";

export default function Footer() {
  const [activeDoc, setActiveDoc] = useState(null);

  return (
    <footer
      className="px-6 py-12 bg-bg-soft text-text-primary"
      aria-label="Footer"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-48">

        {/* About Section */}
        <section>
          <h2 className="font-semibold text-lg mb-4 text-text-primary">
            About Vector Migration
          </h2>
          <p className="text-sm leading-relaxed text-text-secondary">
            Vector Migration simplifies the migration of vector data between
            Qdrant, Pinecone, Weaviate, Chroma and Milvus. It supports AI developers,
            data engineers, and ML researchers for seamless database transitions.
          </p>
        </section>

        {/* Legal Section */}
        <section>
          <h2 className="font-semibold text-lg mb-4 text-text-primary">
            Legal
          </h2>
          <ul className="space-y-2 text-sm">
            {["terms", "privacy", "data"].map((doc) => (
              <li key={doc}>
                <button
                  onClick={() => setActiveDoc(doc)}
                  className="text-text-secondary hover:text-accent hover:underline transition"
                  aria-label={
                    doc === "terms"
                      ? "View Terms of Service"
                      : doc === "privacy"
                      ? "View Privacy Policy"
                      : "View Data Security Policy"
                  }
                >
                  {doc === "terms"
                    ? "Terms of Service"
                    : doc === "privacy"
                    ? "Privacy Policy"
                    : "Data Security Policy"}
                </button>
              </li>
            ))}
          </ul>
        </section>
      </div>

      {/* Bottom Section */}
      <div className="mt-10 pt-6 text-center text-sm border-t border-border text-text-muted">
        © {new Date().getFullYear()} Vector Migration · Built by{" "}
        <a
          href="https://agileforce.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-text-secondary hover:text-accent transition"
        >
          AgileForce
        </a>
      </div>

      <LegalModal
        open={!!activeDoc}
        type={activeDoc}
        onClose={() => setActiveDoc(null)}
      />
    </footer>
  );
}